import { FrameContext  } from '@farris/devkit';

/**
 * åºç¨ä¸ä¸æåéå·¥å·ç±»
 * @internal
 */
class AppParamUtil {

  /**
   * è·ååºç¨ä¸ä¸æåæ°
   */
  public static get(frameContext: FrameContext, name: string): any {
    const appContext = frameContext.appContext;
    return appContext.getParam(name);
  }

  /**
   * è®¾ç½®åºç¨ä¸ä¸æåæ°
   */
  public static set(frameContext: FrameContext, name: string, value: any) {
    const appContext = frameContext.appContext;
    return appContext.setParam(name, value);
  }
}

export { AppParamUtil };
